export default "__VITE_ASSET__jv2gLi$h__"